import React, { useState } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { ButtonSizeTP } from 'submodules/nerit-framework-ui/common/components/button/inner/ButtonSizeTP'
import { PermissionEnum } from 'submodules/nerit-aquatec-sdk/services/auth/authenticate/enums/PermissionEnum'
import { AccessControlCP } from 'app/components/access-control/AccessControlCP'
import { MatrixResponseDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/responses/MatrixResponseDTO'
import { ModalMatrixCP } from 'modules/collection-performance/components/matrix/modal-matrix/ModalMatrixCP'

interface ICPProps {
    matrix?: MatrixResponseDTO
    buttonSize?: ButtonSizeTP
    onSave: () => void
}

export function ButtonModalMatrixCP(props: ICPProps): JSX.Element {

    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

    return (
        <AccessControlCP permission={PermissionEnum.ROLE_ADMIN}>
            <ButtonCP
                style={{ marginLeft: 10 }}
                onClick={() => setIsModalVisible(true)}
                icon={props.matrix ? 'edit' : 'plus'}
                size={props.buttonSize}
            >
                {props.matrix ? '' : 'Nova Matriz'}
            </ButtonCP>

            <ModalMatrixCP
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                matrix={props.matrix}
                onSave={() => {
                    setIsModalVisible(false)
                    props.onSave()
                }}
            />
        </AccessControlCP>
    )
}
